import React, { useState } from "react";
import About from "./pages/About";
import Catering from "./pages/Catering";
import Contact from "./pages/Contact";
import Cookies from "./pages/Cookies";
import Home from "./pages/Home";
import Merch from "./pages/Merch";
import Recipes from "./pages/Recipes";
import styles from "./kurtis.module.css";
import logo from "./components/logo.png";

export default function Curtis() {
const [activeTab,  setActiveTab] = useState("home");

  return (
    <div className={styles.curtisBody}>
      {/* Header */}
      <header className={styles.header}>
      <div className={styles.logo}>
        <img src = {logo} alt = "logo"></img></div>


      <nav className={styles.tabs}>
        {[
            ["home", "Home"],
            ["about", "About Us"],
            ["cookies", "Cookies"],
            ["catering", "Catering"],
            ["merch", "Merch"],
            ["recipes", "Recipes"],
            ["contact", "Contact Us"],
          ].map(([key, label]) => (
          <button
            key={key}
            className={`${styles.tabButton} ${
            activeTab === key ? styles.active : ""
            }`}
            onClick={() => setActiveTab(key)}
          >
            {label}
          </button>
        ))}
      </nav>
      </header>

      {/* Main content */}
      <main className={styles.main}>
        {activeTab === "home" && <Home />}
        {activeTab === "about" && <About />}
        {activeTab === "cookies" && <Cookies />}
        {activeTab === "catering" && <Catering />}
        {activeTab === "merch" && <Merch />}
        {activeTab === "recipes" && <Recipes />}
        {activeTab === "contact" && <Contact />}
      </main>


      <footer className={styles.footer}>
        &copy; 2025 Curty's Kooky
      </footer>
    </div>
  );
}
